import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHero = ({ eyebrow, title, subtitle, image, crumbs = [] }) => (
  <section className="relative pt-[72px] bg-js-charcoal overflow-hidden">
    <div className="absolute inset-0">
      <img src={image} alt={title} className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-js-charcoal/85 via-js-charcoal/70 to-js-charcoal/90" />
    </div>
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-24 md:py-32">
      <nav className="flex items-center gap-1.5 text-white/50 text-xs mb-6" data-testid="breadcrumbs">
        <Link to="/" className="hover:text-white">Home</Link>
        {crumbs.map((c) => (
          <span key={c.label} className="flex items-center gap-1.5">
            <ChevronRight size={13} />
            {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-white/80">{c.label}</span>}
          </span>
        ))}
      </nav>
      {eyebrow && <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-js-red font-semibold text-sm tracking-wide">{eyebrow}</motion.span>}
      <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-display font-extrabold text-white text-4xl md:text-6xl lg:text-7xl tracking-tighter mt-3 max-w-4xl text-balance">
        {title}
      </motion.h1>
      {subtitle && <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }} className="mt-5 text-white/70 text-lg max-w-2xl leading-relaxed">{subtitle}</motion.p>}
    </div>
  </section>
);
